<div class="toggle-container">
  <p>Select a chat bot mode:</p>

  <div class="mode-container">
    <label *ngFor="let mode of modes">
      <input
        type="radio"
        name="chatMode"
        [value]="mode"
        [(ngModel)]="selectedMode"
        (change)="onModeChange(mode)"
      />
      <p>{{ mode }}</p>
    </label>
  </div>
</div>
